import React from "react";
import PropTypes from "prop-types";

import Log from "utils/log";
import { ENVIRONMENT } from "config/constants";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    Log.logger(error, "error", info, false);
  }

  render() {
    if (this.state.error) {
      // Render the error visibly in dev and staging. In prod, just don't render the content at all
      if (ENVIRONMENT === "production") return null;
      return (
        <>
          <pre>{this.state.error.message}</pre>
          <pre>{this.state.info.componentStack}</pre>
        </>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};
